<section class="wrapper">
    <p class="helpful-title helpful-links-text">{{ title() }}</p>
    <div class="links">
        @for (link of links(); track link.label) {
            <p class="link-item helpful-link helpful-links-text" trackCLick (libAccessibleClick)="navigateTo(link.url)">
                <span>{{ link.label }}</span>
                <mat-icon svgIcon="ico_arrow_right"></mat-icon>
            </p>
        }
    </div>
</section>
